import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/lib/auth";
import AppShell from "@/components/AppShell";
import Login from "@/pages/Login";
import AuthCallback from "@/pages/AuthCallback";
import TriagePage from "@/pages/TriagePage";
import HistoryPage from "@/pages/HistoryPage";
import AdminPage from "@/pages/AdminPage";
import StatsPage from "@/pages/StatsPage";
import InfoPage from "@/pages/InfoPage";
import BillingPage from "@/pages/BillingPage";
import { BillingSuccess, BillingCancel } from "@/pages/BillingResult";
import SplashScreen from "@/components/SplashScreen";
import IdleTimer from "@/components/IdleTimer";

function Protected({ children, adminOnly = false }) {
  const { user, loading } = useAuth();
  const loc = useLocation();
  if (loc.state?.user) return <AppShell>{children}</AppShell>;
  if (loading) return <div className="min-h-screen flex items-center justify-center text-slate-500">Caricamento…</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (adminOnly && user.role !== "admin") return <Navigate to="/triage" replace />;
  return <AppShell>{children}</AppShell>;
}

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/billing/success" element={<BillingSuccess />} />
      <Route path="/billing/cancel" element={<BillingCancel />} />
      <Route path="/triage" element={<Protected><TriagePage /></Protected>} />
      <Route path="/history" element={<Protected><HistoryPage /></Protected>} />
      <Route path="/admin" element={<Protected adminOnly><AdminPage /></Protected>} />
      <Route path="/stats" element={<Protected adminOnly><StatsPage /></Protected>} />
      <Route path="/billing" element={<Protected><BillingPage /></Protected>} />
      <Route path="/info" element={<Protected><InfoPage /></Protected>} />
      <Route path="*" element={<Navigate to="/triage" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <div className="App">
      <SplashScreen />
      <BrowserRouter>
        <AuthProvider>
          <IdleTimer />
          <AppRouter />
          <Toaster position="top-right" richColors />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}
